<template>
  <div class="create">
    <form
      class="chi-form"
      @submit.prevent="handleSubmit"
    >
    <h2 v-if="classTeacher.state.role === 'testAdmin'">School Noticeboard</h2>
      <label>Title:</label>
      <input
        v-model="title"
        type="text"
        required
      >
      <label>Content:</label>
      <textarea
        v-model="body"
        required
      />
      <button>Publish Announcement</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import { db, serverTimestamp, addDoc, collection } from '@/firebase/config'

export default {
  props: ['classTeacher'],
  setup (props, context) {
    const title = ref('')
    const body = ref('')

    const handleSubmit = async () => {
      const post = {
        title: title.value,
        content: body.value,
        createdAt: serverTimestamp()
      }
      if (props.classTeacher.state.role === 'teacher') {
        await addDoc(collection(db, '/schools/inspire-schools/' +
        props.classTeacher.state.grade + '/classannouncements/' + props.classTeacher.state.role), post)
        context.emit('newClassAnnouncementCreated')
      }
      if (props.classTeacher.state.role === 'testAdmin') {
        await addDoc(collection(db, '/schools/inspire-schools/announcements'), post)
        context.emit('newClassAnnouncementCreated')
      }
    }

    return { body, title, handleSubmit }
  }
}
</script>

<style scoped>
  .create .chi-form {
    max-width: 480px;
    margin: 0 auto;
    text-align: left;
  }
  .create input, textarea {
    display: block;
    margin: 10px 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 20px;
  }
  .create textarea {
    height: 160px;
  }
  .create .chi-form label {
    display: inline-block;
    margin-top: 30px;
    position: relative;
    font-size: 20px;
    color: var(--sidebar-item-hover);
    margin-bottom: 10px;
    text-transform: none;
  }
  .create .chi-form button {
    display: block;
    margin-top: 30px;
    background: var(--sidebar-item-hover);
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 18px;
    border-radius: 20px;
  }
</style>
